import { ARTICLE_TYPE } from '@root/app.constant';
export class ArticleData {
  imagePath: string;
  pdfUrl: string;
  id: number;
  type: string;
  title: string;
  htmlContent: string;
  year: string;
  month: string;
  shortDesc: string;
  video: string;
}
